<template>
  <div id="position">
    <div
      v-if="positionShow"
      class="circle_list flex flex-direction align-center justify-between"
    >
      <div
        class="circle cs"
        :class="{ current: index == currentIndex }"
        v-for="(item, index) in positions"
        @click="
          currentIndex = index;
          didClick_tab(item, index);
        "
        :key="index"
      >
        <div class="boxhover">
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Cookie from "js-cookie";

export default {
  name: "Position",
  data() {
    return {
      positionShow: false,
      currentIndex: -1,
      positions: [
        {
          id: "header",
          name: "首页",
        },
        {
          id: "introduce",
          name: "大会介绍",
        },
        {
          id: "agenda",
          name: "大会议程",
        },
        {
          id: "guest",
          name: "重磅嘉宾",
        },
        {
          id: "bigView",
          name: "大咖观点",
        },
        // {
        //   id: "parallelSessions",
        //   name: "区域活动",
        // },
        {
          id: "developer",
          name: "开发者社区",
        },
        {
          id: "sandbox",
          name: "沙箱实验室",
        },
        {
          id: "partner",
          name: "合作伙伴",
        },
        {
          id: "media",
          name: "大会媒体",
        },
        {
          id: "news",
          name: "热门资讯",
        },
        {
          id: "videos",
          name: "精彩视频",
        },

        // {
        //   id: "exhibition",
        //   name: "展览展示",
        // },

        // {
        //   id: "guide",
        //   name: "参会指南",
        // },
      ],
      putType: false,
    };
  },
  mounted() {
    // 监听滚动事件
    window.addEventListener(
      "scroll",
      _.debounce(
        () => {
          this.onScroll();
        },
        200,
        false
      ),
      true
    );
    this.putType = !!(this.$route.query.putType || Cookie.get("putType"));
    if (this.putType) {
      this.positions = [
        {
          id: "header",
          name: "首页",
        },
        {
          id: "introduce",
          name: "大会介绍",
        },
        {
          id: "agenda",
          name: "大会议程",
        },
        {
          id: "parallelSessions",
          name: "分会场联动",
        },
        {
          id: "guest",
          name: "重磅嘉宾",
        },
        {
          id: "developer",
          name: "开发者社区",
        },
        {
          id: "sandbox",
          name: "沙箱实验室",
        },
        {
          id: "partner",
          name: "合作伙伴",
        },
        {
          id: "media",
          name: "大会媒体",
        },
        {
          id: "news",
          name: "热门资讯",
        },
        // {
        //   id: "videos",
        //   name: "精彩视频",
        // },
        // {
        //   id: "bigView",
        //   name: "大咖观点",
        // },
        // {
        //   id: "exhibition",
        //   name: "展览展示",
        // },

        // {
        //   id: "guide",
        //   name: "参会指南",
        // },
      ];
    }
    //监听不是 home跳页到 home
    // if (this.$route.params.id) {
    //   this.didClick_tab({ id: this.$route.params.id }, this.$route.params.idx);
    // }
  },
  destroy() {
    // 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    didClick_tab(item, idx) {
      //埋码
      window._hw("send", "action", "index_left_menu_btn_click", {
        left_menu_btn_name: item.name,
      });
      let targetbox = document.getElementById(item.id);
      document.body.scrollTop = document.documentElement.scrollTop =
        targetbox.offsetTop - 60;
      // this.ScrollTop(targetbox.offsetTop - 60, 500); //移出滚动效果
    },
    ScrollTop(number = 0, time) {
      //移出滚动效果
      if (!time) {
        document.body.scrollTop = document.documentElement.scrollTop = number;
        return number;
      }
      const spacingTime = 20; // 设置循环的间隔时间  值越小消耗性能越高
      let spacingInex = time / spacingTime; // 计算循环的次数
      let nowTop = document.body.scrollTop + document.documentElement.scrollTop; // 获取当前滚动条位置
      let everTop = (number - nowTop) / spacingInex; // 计算每次滑动的距离
      let scrollTimer = setInterval(() => {
        if (spacingInex > 0) {
          spacingInex--;
          this.ScrollTop((nowTop += everTop));
        } else {
          clearInterval(scrollTimer); // 清除计时器
        }
      }, spacingTime);
    },
    // 滚动监听器
    onScroll() {
      // 获取所有锚点元素
      const navContents = document.querySelectorAll(
        ".home-container .page-box"
      );
      // 所有锚点元素的 offsetTop
      const offsetTopArr = [];
      navContents.forEach((item) => {
        offsetTopArr.push(item.offsetTop - 70);
      });
      // 获取当前文档流的 scrollTop
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      //若当前 scrollTop高度 小于第一个定位点，不显示锚点定位块
      this.positionShow = scrollTop < offsetTopArr[0] ? false : true;
      // 定义当前点亮的导航下标
      let navIndex = 0;
      for (let n = 0; n < offsetTopArr.length; n++) {
        // 如果 scrollTop 大于等于第 n 个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
        // 那么此时导航索引就应该是 n 了
        if (scrollTop >= offsetTopArr[n]) {
          navIndex = n;
        }
      }
      // 把下标赋值给 vue 的 data
      this.currentIndex = navIndex;
    },
  },
};
</script>

<style lang="scss" scoped>
#position {
  width: 16px;
  height: 308px;
  position: fixed;
  top: calc(50vh - 154px);
  left: 45px;
  z-index: 100;
  .circle_list {
    width: 100%;
    height: 308px;
    .circle {
      width: 12px;
      height: 12px;
      border: 1px solid;
      background: #cccccc;
      border-radius: 50%;
      color: transparent;
      position: relative;
      .boxhover {
        display: none;
      }
    }
    //悬浮显示 模块名称
    .circle:hover {
      .boxhover {
        display: block;
        position: absolute;
        left: 30px;
        top: -8px;
        width: auto;
        height: 24px;
        white-space: nowrap;
        padding: 0 5px;
        background: #b4251e;
        opacity: 1;
        font-size: 16px;
        font-family: Microsoft YaHei-Light;
        font-weight: 400;

        color: #ffffff;
        line-height: 24px;
      }
      .boxhover::before {
        content: "";
        width: 0;
        height: 0;
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-left: 6px solid transparent;
        border-right: 6px solid #b4251e;
        position: absolute;
        left: -12px;
        top: calc(50% - 6px);
      }
    }
    /*Firefox*/
    @-moz-document url-prefix() {
      //悬浮显示 模块名称
      .circle:hover {
        .boxhover {
          display: block;
          position: absolute;
          left: 30px;
          top: -8px;
          width: auto;
          height: 24px;
          white-space: nowrap;
          padding: 0 5px;
          background: #b4251e;
          opacity: 1;
          font-size: 16px;
          font-family: Microsoft YaHei-Light;
          font-weight: 400;

          color: #ffffff;
          line-height: 24px;
        }
        .boxhover::before {
          content: "";
          width: 0;
          height: 0;
          border-top: 6px solid transparent;
          border-bottom: 6px solid transparent;
          border-left: 6px solid transparent;
          border-right: 6px solid #b4251e;
          position: absolute;
          left: -10px !important;
          top: calc(50% - 6px);
        }
      }
    }

    .current {
      width: 14px;
      height: 14px;
      opacity: 1;
      background: transparent;
      border: 2px solid #b4251e;
      border-radius: 50%;
    }
  }
}
@media screen and (max-width: 992px) {
  #position {
    display: none;
  }
}
</style>
